import {BuilderParameterInterface, BuilderTemplateInterface, BuilderParametersByType} from "@tool/Builder/Builder.types";

const utm_source_facebook: BuilderParameterInterface = {
    // id: 'utm_source_facebook',
    type: "utm_source",
    name: "facebook",
    notes: '',
};

const utm_source_twitter: BuilderParameterInterface = {
    // id: 'utm_source_twitter',
    type: "utm_source",
    name: "twitter",
    notes: '',
};

const utm_source_linkedin: BuilderParameterInterface = {
    // id: 'utm_source_linkedin',
    type: "utm_source",
    name: "linkedin",
    notes: '',
};

const utm_source_instagram: BuilderParameterInterface = {
    // id: 'utm_source_instagram',
    type: "utm_source",
    name: "instagram",
    notes: '',

};

const utm_source_pinterest: BuilderParameterInterface = {
    // id: 'utm_source_pinterest',
    type: "utm_source",
    name: "pinterest",
    notes: '',

};

const utm_source_google: BuilderParameterInterface = {
    // id: 'utm_source_google',
    type: "utm_source",
    name: "google",
    notes: '',

};

const utm_source_youtube: BuilderParameterInterface = {
    // id: 'utm_source_youtube',
    type: "utm_source",
    name: "youtube",
    notes: '',

};

const utm_source_bing: BuilderParameterInterface = {
    // id: 'utm_source_bing',
    type: "utm_source",
    name: "bing",
    notes: '',

};

const utm_source_newsletter: BuilderParameterInterface = {
    // id: 'utm_source_newsletter',
    type: "utm_source",
    name: "newsletter",
    notes: '',

};

const utm_source_direct: BuilderParameterInterface = {
    // id: 'utm_source_direct',
    type: "utm_source",
    name: "direct",
    notes: '',

};

const utm_source_automation: BuilderParameterInterface = {
    // id: 'utm_source_automation',
    type: "utm_source",
    name: "automation",
    notes: '',

};

const utm_source_affiliate: BuilderParameterInterface = {
    // id: 'utm_source_affiliate',
    type: "utm_source",
    name: "affiliate",
    notes: '',

};


const utm_medium_social: BuilderParameterInterface = {
    // id: 'utm_medium_social',
    type: "utm_medium",
    name: "social",
    notes: '',
};

const utm_medium_email: BuilderParameterInterface = {
    // id: 'utm_medium_email',
    type: "utm_medium",
    name: "email",
    notes: '',

};

const utm_medium_cpc: BuilderParameterInterface = {
    // id: 'utm_medium_cpc',
    type: "utm_medium",
    name: "cpc",
    notes: '',

};

const utm_medium_cpm: BuilderParameterInterface = {
    // id: 'utm_medium_cpm',
    type: "utm_medium",
    name: "cpm",
    notes: '',

};

const utm_medium_event: BuilderParameterInterface = {
    // id: 'utm_medium_event',
    type: "utm_medium",
    name: "event",
    notes: '',

};

const utm_medium_billboard: BuilderParameterInterface = {
    // id: 'utm_medium_billboard',
    type: "utm_medium",
    name: "billboard",
    notes: '',

};

const utm_medium_referrer: BuilderParameterInterface = {
    // id: 'utm_medium_referrer',
    type: "utm_medium",
    name: "referrer",
    notes: '',
};


const template_facebook_ads: BuilderTemplateInterface = {
    // id: 'template_facebook_ads',
    name: 'Facebook Ads',
    // utm_string: 'utm_source=facebook&utm_medium=cpc',
    parameters: [
        {type: utm_source_facebook.type, name: utm_source_facebook.name},
        {type: utm_medium_cpc.type, name: utm_medium_cpc.name},
    ],
};

const template_bing_ads: BuilderTemplateInterface = {
    // id: 'template_bing_ads',
    name: 'Bing Ads',
    // utm_string: 'utm_source=bing&utm_medium=cpc',
    parameters: [
        {type: utm_source_bing.type, name: utm_source_bing.name},
        {type: utm_medium_cpc.type, name: utm_medium_cpc.name},
    ],
};

const template_facebook_posts: BuilderTemplateInterface = {
    // id: 'template_facebook_posts',
    name: 'Facebook Post',
    // utm_string: 'utm_source=facebook&utm_medium=social',
    parameters: [
        {type: utm_source_facebook.type, name: utm_source_facebook.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_twitter_post: BuilderTemplateInterface = {
    // id: 'template_twitter_post',
    name: 'Twitter Post',
    // utm_string: 'utm_source=twitter&utm_medium=social',
    parameters: [
        {type: utm_source_twitter.type, name: utm_source_twitter.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_linkedin_post: BuilderTemplateInterface = {
    // id: 'template_linkedin_post',
    name: 'Linkedin Post',
    // utm_string: 'utm_source=linkedin&utm_medium=social',
    parameters: [
        {type: utm_source_linkedin.type, name: utm_source_linkedin.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_instagram_bio: BuilderTemplateInterface = {
    // id: 'template_instagram_bio',
    name: 'Instagram Bio',
    // utm_string: 'utm_source=instagram&utm_medium=social',
    parameters: [
        {type: utm_source_instagram.type, name: utm_source_instagram.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_pinterest_post: BuilderTemplateInterface = {
    // id: 'template_pinterest_post',
    name: 'Pinterest Post',
    // utm_string: 'utm_source=pinterest&utm_medium=social',
    parameters: [
        {type: utm_source_pinterest.type, name: utm_source_pinterest.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_youtube_link: BuilderTemplateInterface = {
    // id: 'template_youtube_link',
    name: 'YouTube Link',
    // utm_string: 'utm_source=youtube&utm_medium=social',
    parameters: [
        {type: utm_source_youtube.type, name: utm_source_youtube.name},
        {type: utm_medium_social.type, name: utm_medium_social.name},
    ],
};

const template_email_newsletter: BuilderTemplateInterface = {
    // id: 'template_email_newsletter',
    name: 'Email - Newsletter',
    // utm_string: 'utm_source=newsletter&utm_medium=email',
    parameters: [
        {type: utm_source_newsletter.type, name: utm_source_newsletter.name},
        {type: utm_medium_email.type, name: utm_medium_email.name},
    ],
};

const template_email_direct: BuilderTemplateInterface = {
    // id: 'template_email_direct',
    name: 'Email - Direct',
    // utm_string: 'utm_source=direct&utm_medium=email',
    parameters: [
        {type: utm_source_direct.type, name: utm_source_direct.name},
        {type: utm_medium_email.type, name: utm_medium_email.name},
    ],
};

const template_email_automation: BuilderTemplateInterface = {
    // id: 'template_email_automation',
    name: 'Email - Automation',
    // utm_string: 'utm_source=automation&utm_medium=email',
    parameters: [
        {type: utm_source_automation.type, name: utm_source_automation.name},
        {type: utm_medium_email.type, name: utm_medium_email.name},
    ],
};

export const DemoParameters: BuilderParametersByType = {
    utm_source: [
        utm_source_facebook,
        utm_source_twitter,
        utm_source_linkedin,
        utm_source_instagram,
        utm_source_pinterest,
        utm_source_google,
        utm_source_youtube,
        utm_source_bing,
        utm_source_newsletter,
        utm_source_direct,
        utm_source_automation,
        utm_source_affiliate,
    ],
    utm_medium: [
        utm_medium_social,
        utm_medium_email,
        utm_medium_cpc,
        utm_medium_cpm,
        utm_medium_event,
        utm_medium_billboard,
        utm_medium_referrer,
    ],
    utm_campaign: [],
    utm_content: [],
    utm_term: [],
}

export const DemoTemplates: BuilderTemplateInterface[] = [
    template_facebook_ads,
    template_bing_ads,
    template_facebook_posts,
    template_twitter_post,
    template_linkedin_post,
    template_instagram_bio,
    template_pinterest_post,
    template_youtube_link,
    template_email_newsletter,
    template_email_direct,
    template_email_automation,
]